import { LOGICAL_CLAIM_STATUS } from '../constants/constants';

export const FilterClaimsByPolicyNo = ({ claims, policyNumber }) => {
  return claims.filter((claim) => {
    const policyNum = claim.PolicyNumber || '';
    const fullPolicyNum = claim.FullPolicyNumber || '';
    const claimPolicyNum = claim.ClaimPolicyNumber || '';

    return (
      policyNumber.includes(policyNum) || fullPolicyNum.includes(policyNumber) || claimPolicyNum.includes(policyNumber)
    );
  });
};

const COMPLETED_CLAIM_DISPLAY_DELAY_DAYS = 2;

const shouldDisplayNotCoveredClaimAsCompleted = (history, dateNow = new Date()) => {
  if (!history?.length) return false;

  const lastEntry = history[history.length - 1];
  if (!lastEntry?.TransactionDate) return false;

  const transactionDate = new Date(lastEntry.TransactionDate);
  if (Number.isNaN(transactionDate.getTime())) return false;

  const dayDifference = Math.floor((dateNow.getTime() - transactionDate.getTime()) / (1000 * 3600 * 24));

  return dayDifference >= COMPLETED_CLAIM_DISPLAY_DELAY_DAYS;
};

const isNotAdmittedOrCoveredLogicalClaim = (logicalClaim) =>
  logicalClaim?.Status === LOGICAL_CLAIM_STATUS.NOTADMITTED || logicalClaim?.Status === LOGICAL_CLAIM_STATUS.NOTCOVERED;

const shouldMoveCompletedClaimToOpen = (claim, dateNow) =>
  claim?.LogicalClaims?.some(
    (logicalClaim) =>
      isNotAdmittedOrCoveredLogicalClaim(logicalClaim) &&
      !shouldDisplayNotCoveredClaimAsCompleted(logicalClaim.LogicalClaimHistory, dateNow)
  );

export const regroupRecentNotAdmittedClaims = (openClaims, completedClaims, dateNow = new Date()) => {
  const claimsToMove = completedClaims.filter((claim) => shouldMoveCompletedClaimToOpen(claim, dateNow));

  if (!claimsToMove.length) {
    return { openClaims, completedClaims };
  }

  return {
    openClaims: [...openClaims, ...claimsToMove],
    completedClaims: completedClaims.filter((claim) => !claimsToMove.includes(claim))
  };
};
